<button
  [attr.type]="type"
  [disabled]="disabled || loading"
  [ngClass]="{
    'btn-primary': variant === 'primary',
    'btn-secondary': variant === 'secondary',
    'btn-error': variant === 'error',
    'btn-black': variant === 'black',
    'btn-black-invert': variant === 'black-invert',
    'btn-disabled': this.disabled,
    'btn-ghost': variant === 'ghost',
    'size-medium': size === 'medium',
    'size-small': size === 'small',
    'size-small-shrink': size === 'small-shrink',
    'size-medium-shrink': size === 'medium-shrink'
  }"
  class="btn-base {{ extraBtnClass }}"
  [disabled]="loading"
>
  <div
    class="w-full flex justify-center items-center"
    [ngClass]="{ 'flex-row-reverse': iconPosition === 'right' }"
  >
    @if (loading) {
      <div
        class="animate-spin rounded-full h-base w-base border-b-2 border-white {{ loadingExtraClass }}"
      ></div>
    }
    @if (!loading && icon) {
      <div>
        <div class="flex items-center justify-center">
          @switch (iconType) {
            @case ('iconPath') {
              <img class="{{ iconClass }}" [src]="icon" />
            }
            @case ('svgIcon') {
              <svg-icon [key]="icon" class="{{ iconClass }}"></svg-icon>
            }
            @default {
              <mat-icon class="{{ iconClass }}">{{ icon }}</mat-icon>
            }
          }
        </div>
      </div>
    }
    <div
      [ngClass]="{
        'mr-sm': (icon || loading) && iconPosition === 'right' && !onlyIcon,
        'ml-sm': (icon || loading) && iconPosition === 'left' && !onlyIcon,
        'lowercase first-letter:uppercase': lowercase
      }"
    >
      <ng-content></ng-content>
    </div>
  </div>
</button>
